import React from "react";
import ModalShell from "../../../components/common/ModalShell";
import CustomDropdown from "../../../components/forms/CustomDropdown";
import ui from "../DashboardUI.module.css";

export default function MilestoneEditModal({
  milestone,
  onMilestoneChange,
  activeTab,
  onTabChange,
  employeeSearch,
  onEmployeeSearchChange,
  searchFocused,
  onSearchFocusChange,
  availableEmployees,
  onClose,
  onSave,
}) {
  return (
    <ModalShell onClose={onClose} closeOnOverlayClick={false} overlayClassName={ui.modalOverlay}>
      <div className={ui.modal}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px',
          borderBottom: '1px solid #e5e7eb',
          background: '#f9fafb'
        }}>
          <h2 style={{ margin: 0, fontSize: '1.125rem', fontWeight: 600, color: '#111827' }}>
            Edit Milestone
          </h2>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              color: '#6b7280',
              cursor: 'pointer',
              padding: '0',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            ×
          </button>
        </div>

        {/* Tabs */}
        <div className={ui.modalTabs}>
          {["Overview", "Team"].map(tab => (
            <button
              key={tab}
              className={`${ui.tabButton} ${activeTab === tab ? ui.activeTab : ""}`}
              onClick={() => onTabChange(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className={ui.modalContent}>
          {/* === Overview Tab === */}
          {activeTab === "Overview" && (
            <>
              <div className={ui.inputGroup}>
                <label>Name</label>
                <input
                  type="text"
                  value={milestone.milestone_name}
                  onChange={(e) =>
                    onMilestoneChange((prev) => ({
                      ...prev,
                      milestone_name: e.target.value,
                    }))
                  }
                />
              </div>

              <div className={ui.inputGroup}>
                <label>Milestone Dates</label>
                <div style={{ display: 'flex', gap: '16px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '0.85rem', color: '#6b7280' }}>Start Date</label>
                    <input
                      type="date"
                      value={milestone.start_date?.slice(0, 10) || ""}
                      onChange={(e) =>
                        onMilestoneChange((prev) => ({
                          ...prev,
                          start_date: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '0.85rem', color: '#6b7280' }}>Due Date</label>
                    <input
                      type="date"
                      value={milestone.due_date?.slice(0, 10) || ""}
                      onChange={(e) =>
                        onMilestoneChange((prev) => ({
                          ...prev,
                          due_date: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>

              <div className={ui.inputGroup}>
                <label>Status</label>
                <CustomDropdown
                  options={[
                    { value: 'open', label: 'Open' },
                    { value: 'in progress', label: 'In Progress' },
                    { value: 'completed', label: 'Completed' },
                  ]}
                  value={milestone.status}
                  onChange={(val) =>
                    onMilestoneChange((prev) => ({
                      ...prev,
                      status: val,
                    }))
                  }
                  fullWidth
                />
              </div>

              <div className={ui.inputGroup}>
                <label>Description</label>
                <textarea
                  value={milestone.description || ""}
                  onChange={(e) =>
                    onMilestoneChange((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />
              </div>
            </>
          )}

          {/* === Team Tab === */}
          {activeTab === "Team" && (
            <>
              <div className={ui.inputGroup}>
                <label>Search people by name or job title</label>
                <input
                  type="text"
                  placeholder="Search..."
                  value={employeeSearch}
                  onChange={(e) => onEmployeeSearchChange(e.target.value)}
                  onFocus={() => onSearchFocusChange(true)}
                  onBlur={() => setTimeout(() => onSearchFocusChange(false), 200)}
                />
              </div>

              {/* Filtered results */}
              {searchFocused && (
                <div className={ui.searchResults}>
                  {availableEmployees
                    .filter(emp =>
                      (emp.name + emp.job_title).toLowerCase().includes(employeeSearch.toLowerCase())
                    )
                    .filter(emp =>
                      !milestone.team_members?.some(m => m.id === emp.id)
                    )
                    .map(emp => (
                      <div
                        key={emp.id}
                        className={ui.searchItem}
                        onClick={() => {
                          const newMembers = [
                            ...(milestone.team_members || []),
                            { ...emp, role: "" }
                          ];
                          onMilestoneChange(prev => ({
                            ...prev,
                            team_members: newMembers
                          }));
                          onEmployeeSearchChange("");
                        }}
                      >
                        {emp.name} — {emp.job_title}
                      </div>
                    ))}
                </div>
              )}

              {milestone.team_members?.length > 0 && (
                <div className={ui.assignedList}>
                  {milestone.team_members.map((emp, idx) => (
                    <div key={emp.id} className={ui.assignedItem}>
                      <span>{emp.name}</span>
                      <input
                        type="text"
                        placeholder="Role in milestone"
                        value={emp.role || ""}
                        onChange={(e) => {
                          const updated = [...milestone.team_members];
                          updated[idx].role = e.target.value;
                          onMilestoneChange(prev => ({
                            ...prev,
                            team_members: updated
                          }));
                        }}
                      />
                      <button
                        type="button"
                        className={ui.removeButton}
                        onClick={() => {
                          const filtered = milestone.team_members.filter(e => e.id !== emp.id);
                          onMilestoneChange(prev => ({
                            ...prev,
                            team_members: filtered
                          }));
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>

        {/* Actions */}
        <div className={ui.actions}>
          <button type="button" className={ui.cancelButton} onClick={onClose}>
            Close
          </button>
          <button type="button" className={ui.saveButton} onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </ModalShell>
  );
}
